import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    color: "black",
    fontSize: theme.typography.pxToRem(16),
  },
  controlButton: {
    padding: 0,
    color: "#F15A28",
    flex: 0,
  },
  button: {
    border: "none",
    color: "#000000",
  },
  monthWrapper: {
    flex: 1,
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  month: {
    margin: "0 0.5rem",
    fontFamily: "Lato",
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(16),
  },
}));
